import * as z from "zod";

export const queryDom = {
  name: "queryDom" as const,
  input: z.object({
    dom: z.string().describe("The DOM HTML string to analyze"),
    query: z.string().describe("The question about the DOM structure"),
    styles: z
      .string()
      .optional()
      .describe("The CSS styles present on the page"),
  }),
  output: z.object({
    answer: z.string().describe("The answer to the query about the DOM"),
  }),
};
